import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "flatpickr/dist/flatpickr.min.css";
import PlaneIco from "./assets/svgImages/PlaneIco.svg";
import PlaneIcoTwo from "./assets/img/PlaneIco-2.png";
import StopPlaneImg from "./assets/img/stopPlane.png";
import { convertCurrency, getMarkupSettings } from "../services/services";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { formatDateWithWeekday } from "./formatDateWithWeekday";
import { getAirlineLogoUrl, flightPriceCheck } from "../services/services";
const FlightListContent = ({
  flights,
  convertedPrices,
  selectedCurrency,
  totalPassengerCount,
}) => {
  const [airports, setAirports] = useState([]);
  const [markupSettings, setMarkupSettings] = useState({
    markupTypeListing: 'percentage',
    markupValueListing: 0.00001,
    markupTypeBaseFare: 'percentage',
    markupValueBaseFare: 0.0001, // default GBP value
    markupTypePassenger: 'percentage',
    markupValuePassenger: 0.0001
  });
  const [isCurrencyLoading, setIsCurrencyLoading] = useState(false);
  const [finalAdjustedPrices, setFinalAdjustedPrices] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [pendingFlightData, setPendingFlightData] = useState(null);
  const [checkingIndex, setCheckingIndex] = useState(null);

  const navigate = useNavigate();
  const parseDirectionTotalTimeToHoursMins = (str) => {
    if (!str) return "";

    const dayMatch = str.match(/(\d+)d/);
    const hourMatch = str.match(/(\d+)h/);
    const minMatch = str.match(/(\d+)m/);

    const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
    const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
    const mins = minMatch ? parseInt(minMatch[1], 10) : 0;

    const totalHours = days * 24 + hours;

    return `${totalHours}h ${mins}m`;
  };

  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const response = await axios.get(
          "https://raw.githubusercontent.com/mwgg/Airports/master/airports.json"
        );
        const airportList = Object.values(response.data).filter(
          (airport) => airport.iata
        );
        setAirports(airportList);
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    };
    fetchAirports();
  }, []);
  useEffect(() => {
    const fetchSettings = async () => {
      await getMarkupSettings(
        (response) => {
          const settings = {};
          response.forEach((item) => {
            settings[item.key] = item.value;
          });
          setMarkupSettings((prev) => ({
            ...prev,
            markupTypeListing: settings.markupTypeListing || "percentage",
            markupValueListing:
              parseFloat(settings.markupValueListing) || 0.00001,
            markupTypeBaseFare: settings.markupTypeBaseFare || "percentage",
            markupValueBaseFare:
              parseFloat(settings.markupValueBaseFare) || 0.00001,
            markupTypePassenger: settings.markupTypePassenger || "percentage",
            markupValuePassenger:
              parseFloat(settings.markupValuePassenger) || 0.00001,
          }));
        },
        (error) => {
          console.error("Failed to fetch markup settings", error);
          // Use defaults if API fails
          setMarkupSettings({
            markupTypeListing: 'percentage',
            markupValueListing: 0.001,
            markupTypeBaseFare: 'fixed',
            markupValueBaseFare: 0.001,
            markupTypePassenger: 'percentage',
            markupValuePassenger: 0.001,
          });
        }
      );
    };

    fetchSettings();
  }, []);
  useEffect(() => {
    const applyMarkup = async () => {
      if (!flights || flights.length === 0) return;
      setIsCurrencyLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 0));
      const adjustedPrices = await Promise.all(
        flights.map(async (flight, index) => {
          const basePrice =
            convertedPrices?.[index] ??
            flight.BookingComponent?.TotalPrice ??
            0;

          let finalPrice = basePrice;

          if (totalPassengerCount > 1) {
            if (markupSettings.markupTypePassenger === "percentage") {
              finalPrice =
                basePrice * (1 + markupSettings.markupValuePassenger / 100);
            } else {
              const convertedFixed = await convertCurrency(
                markupSettings.markupValuePassenger,
                "GBP",
                selectedCurrency
              );
              finalPrice = basePrice + convertedFixed;
            }
          } else {
            if (markupSettings.markupTypeListing === "percentage") {
              finalPrice =
                basePrice * (1 + markupSettings.markupValueListing / 100);
            } else {
              const convertedFixed = await convertCurrency(
                markupSettings.markupValueListing,
                "GBP",
                selectedCurrency
              );
              finalPrice = basePrice + convertedFixed;
            }
          }

          return finalPrice;
        })
      );
      setIsCurrencyLoading(false);
      setFinalAdjustedPrices(adjustedPrices);
    };

    if (flights.length && convertedPrices) {
      applyMarkup();
    }
  }, [
    flights,
    convertedPrices,
    markupSettings,
    selectedCurrency,
    totalPassengerCount,
  ]);

  const getCityByIata = (iataCode) => {
    const airport = airports.find((a) => a.iata === iataCode);
    return airport ? `${airport.city} (${iataCode})` : iataCode;
  };

  const calculateLayovers = (segments) => {
    return segments.slice(0, -1).map((seg, i) => {
      const arrival = new Date(seg.Arrival);
      const departure = new Date(segments[i + 1].Departure);
      const mins = Math.round((departure - arrival) / 60000);
      return `${Math.floor(mins / 60)}h ${mins % 60}m`;
    });
  };
  const handleBookNow = (flight, index) => {
    setCheckingIndex(index);

    const direction = flight.Directions[0][0];
    const requestBody = {
      ItemCodeRef: flight.ItemCodeRef,
      SegmentCodeRefs: direction.Segments.map((s) => s.SegmentCodeRef),
      UniqueTransID: flight.UniqueTransID,
    };

    flightPriceCheck(
      requestBody,
      (res) => {
        const result = res?.data;
        setCheckingIndex(null);

        if (result?.IsBaggageChanged) {
          setShowPopup(true);
          setPopupData(result);
          setPendingFlightData({ flight, direction });
        } else {
          navigate("/FlightReservationOne", {
            state: prepareBookingState(flight, direction),
          });
        }
      },
      (err) => {
        setCheckingIndex(null);
        console.error("Price check failed", err);
        navigate("/FlightReservationOne", {
          state: prepareBookingState(flight, direction),
        });
      }
    );
  };

  const prepareBookingState = (flight, direction) => ({
    segments: direction.Segments,
    layovers: calculateLayovers(direction.Segments),
    ItemCodeRef: flight.ItemCodeRef,
    SegmentCodeRefs: direction.Segments.map((s) => s.SegmentCodeRef),
    UniqueTransID: flight.UniqueTransID,
    priceDetails: {
      TotalPrice: flight.BookingComponent?.TotalPrice,
      BasePrice: flight.BookingComponent?.BasePrice,
      Taxes: flight.BookingComponent?.Taxes,
      Discount: flight.BookingComponent?.DiscountPrice,
      TotalPriceWithTax: flight.BookingComponent?.TotalPriceWithTax,
      Refundable: flight.Refundable,
    },
    serviceClass: direction.Segments[0].ServiceClass,
  });
  const proceedBooking = () => {
    setShowPopup(false);
    if (pendingFlightData) {
      const { flight, direction } = pendingFlightData;
      navigate("/FlightReservationOne", {
        state: prepareBookingState(flight, direction),
      });
    }
  };

  return (
    <>
      <ul>
        {flights.map((flight, index) => {
          const direction = flight.Directions[0][0];
          // const carrierCode = direction.PlatingCarrierCode || "OD";
          const carrierCode = flight.PlatingCarrier || "OD";
          const logoUrl = getAirlineLogoUrl(carrierCode);
          const airlineName = flight.PlatingCarrierName;
          // const logoUrl = getAirlineLogoUrl(carrierCode);
          const segments = direction.Segments;
          const originCity = getCityByIata(segments[0].Origin);
          const destinationCity = getCityByIata(
            segments[segments.length - 1].Destination
          );
          const stops = segments.length - 1;
          // const convertedPrice =
          //   convertedPrices?.[index] ?? flight.BookingComponent?.TotalPrice;
          const layovers = [];
          for (let i = 0; i < segments.length - 1; i++) {
            const arrival = new Date(segments[i].Arrival);
            const departure = new Date(segments[i + 1].Departure);
            const layoverMs = departure - arrival;
            const hours = Math.floor(layoverMs / (1000 * 60 * 60));
            const minutes = Math.floor(
              (layoverMs % (1000 * 60 * 60)) / (1000 * 60)
            );
            layovers.push(`${hours}h ${minutes}m`);
          }

          return (
            <li key={flight.ItemCodeRef}>
              <div className="itemWrap">
                <div className="topWrap">
                  <div className="leftWrap">
                    <div className="icoWrap">
                      <img
                        src={logoUrl}
                        className="img-fluid"
                        alt=""
                        style={{
                          maxWidth: "100%",
                          maxHeight: "40px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h2>{airlineName}</h2>
                    {/* <p className="stops-info">{stops} stop{stops !== 1 ? 's' : ''}</p> */}
                  </div>
                  <div className="midSecWrap">
                    <div className="leftWrap">
                      <ul>
                        <li>
                          <span>
                            {formatDateWithWeekday(segments[0].Departure)}
                          </span>
                          <div className="items">
                            <h3>
                              {segments[0].Departure.split(" ")[1].slice(0, 5)}
                            </h3>
                            <p>{originCity}</p>
                            {/* <p>{segments[0].Origin}</p> */}
                          </div>
                        </li>
                        <li>
                          <div className="items">
                            <h4>
                              {parseDirectionTotalTimeToHoursMins(
                                direction.DirectionTotalTime
                              )}
                            </h4>
                            <div className="planeIcoWrap">
                              {stops === 0 && (
                                <img
                                  src={PlaneIco}
                                  className="img-fluid"
                                  alt=""
                                />
                              )}
                              {stops > 0 && (
                                <div className="stop-dots">
                                  {Array(stops)
                                    .fill()
                                    .map((_, i) => (
                                      <div
                                        key={i}
                                        className="stop-dot"
                                        data-tooltip={`Layover at ${getCityByIata(
                                          segments[i].Destination
                                        )}: ${layovers[i]}`}
                                      >
                                        <div className="dot">
                                          <img
                                            src={StopPlaneImg}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </div>
                                        <div className="stop-info">
                                          {getCityByIata(
                                            segments[i].Destination
                                          )}{" "}
                                          <br />
                                          Layover: {layovers[i]}
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </li>
                        <li>
                          <span>
                            {formatDateWithWeekday(
                              segments[segments.length - 1].Arrival
                            )}
                          </span>
                          <div className="items">
                            <h3>
                              {segments[segments.length - 1].Arrival.split(
                                " "
                              )[1].slice(0, 5)}
                            </h3>
                            <p>{destinationCity}</p>
                            {/* <p>{direction.Destination}</p> */}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="rightWrap">
                      <p>
                        Travel Class: <span>{segments[0].ServiceClass}</span>
                      </p>
                      <h2>
                        {/* {selectedCurrency}{" "} */}
                        {/* {finalAdjustedPrices[index] ? Math.round(finalAdjustedPrices[index]).toFixed(2) : "Loading..."} */}
                        {isCurrencyLoading
                          ? "Loading..."
                          : `${selectedCurrency} ${Math.round(
                              finalAdjustedPrices[index]
                            ).toFixed(2)}`}
                      </h2>
                      <button
                        className="btnBook"
                        onClick={() => handleBookNow(flight, index)}
                        disabled={checkingIndex === index}
                      >
                        {checkingIndex === index ? "Checking..." : "Book Now"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="btmWrap">
                  <p>{/* {segments[0].BookingCount} seats remaining */}</p>
                  <p className="clrTxt">
                    {flight.Refundable ? "Refundable" : "Non-Refundable"}
                  </p>
                  <Link to="" className="clrTxt weightTxt">
                    {/* View flight details */}
                  </Link>
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      {showPopup && (
        <div className="baggagePopup">
          <div className="popupInner">
            <h3>Baggage information has changed!</h3>
            <div className="popupBody">
              <div className="topTtlWrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 6V5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5V6M9 21V17C9 16.4696 9.21071 15.9609 9.58579 15.5858C9.96086 15.2107 10.4696 15 11 15H13C13.5304 15 14.0391 15.2107 14.4142 15.5858C14.7893 15.9609 15 16.4696 15 17V21M11 10H13M5 18V12C5 10.4087 5.63214 8.88258 6.75736 7.75736C7.88258 6.63214 9.4087 6 11 6H13C14.5913 6 16.1174 6.63214 17.2426 7.75736C18.3679 8.88258 19 10.4087 19 12V18C19 18.7956 18.6839 19.5587 18.1213 20.1213C17.5587 20.6839 16.7956 21 16 21H8C7.20435 21 6.44129 20.6839 5.87868 20.1213C5.31607 19.5587 5 18.7956 5 18Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>Here is the updated baggage allowance</p>
              </div>
              <div className="mainDataWrap">
                <ul>
                  {popupData?.Directions?.[0]?.[0]?.Segments?.map(
                    (seg, idx) => (
                      <li key={idx}>
                        <div className="itemWrap">
                          <div className="icoWrap">
                            <img
                              src={PlaneIcoTwo}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h4>
                              {" "}
                              {seg.Origin} → {seg.Destination}
                            </h4>
                            <p>
                              {" "}
                              Checked Baggage :{" "}
                              <strong>
                                {" "}
                                {seg.Baggage?.[0]?.Amount}
                                {seg.Baggage?.[0]?.Units}
                              </strong>
                            </p>
                            <p>
                              {" "}
                              Carry-on :{" "}
                              <strong>
                                {seg.CarryBaggage?.[0]?.Amount}{" "}
                                {seg.CarryBaggage?.[0]?.Units}
                              </strong>
                            </p>
                          </div>
                        </div>
                      </li>
                    )
                  )}
                </ul>
                <div className="popupActions">
                  <button onClick={proceedBooking} className="btn">
                    Proceed
                  </button>
                  <button
                    onClick={() => setShowPopup(false)}
                    className="btn btnStay"
                  >
                    Stay on this page
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default FlightListContent;
